import classNames from 'classnames';
import PropTypes from 'prop-types';

import { formatPrice } from '@spotahome/soyuz-currency';
import { trans } from '@spotahome/soyuz/client';

import { transTT } from './utils';
import styles from './PaymentInfo.module.scss';

const CN_PREFIX = 'payment-info';

const getCn = element => styles[`${CN_PREFIX}__${element}`];

const hasSomeDiscount = items =>
  items.some(
    item =>
      !!item.discountType && !!item.discountValue && !!item.priceWithoutOffer
  );

const EMPTY_ARRAY = [];

const PaymentInfoSectionHeader = ({
  price = 0,
  priceWithoutOffer = null,
  dataTest = '',
  name = '',
  payToSpotahome,
  items = EMPTY_ARRAY,
  currencyIsoCode = '',
  priceIsMonthly
}) => {
  const showOriginalPrice = priceWithoutOffer && priceWithoutOffer !== price;
  return (
    <div
      data-test={dataTest}
      className={classNames(getCn('row'), getCn('row--header'))}
    >
      <div
        className={classNames(
          getCn('cell--name-container'),
          getCn('cell--vertical')
        )}
      >
        {name}
        <div className={classNames(getCn('cell--pay-through-container'))}>
          {payToSpotahome
            ? transTT('through_spotahome')
            : transTT('to_landlord')}
        </div>
      </div>
      <div className={classNames(getCn('cell--prices-container'))}>
        {showOriginalPrice && (
          <div className={classNames(getCn('price--without-offer'))}>
            {formatPrice(priceWithoutOffer, currencyIsoCode)}
          </div>
        )}
        {!!price && (
          <span
            className={classNames(getCn('price'), {
              [getCn('price--with-offer')]: hasSomeDiscount(items)
            })}
          >
            {`${formatPrice(price, currencyIsoCode)}${
              priceIsMonthly ? `/${trans('booking-status.month')}` : ''
            }`}
          </span>
        )}
      </div>
    </div>
  );
};

PaymentInfoSectionHeader.propTypes = {
  name: PropTypes.string,
  price: PropTypes.number,
  priceWithoutOffer: PropTypes.number,
  payToSpotahome: PropTypes.bool.isRequired,
  priceIsMonthly: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      price: PropTypes.number,
      priceWithoutOffer: PropTypes.number,
      tooltip: PropTypes.string,
      alreadyPaid: PropTypes.bool,
      dataTest: PropTypes.string,
      discountType: PropTypes.string,
      discountValue: PropTypes.number
    })
  ),
  currencyIsoCode: PropTypes.string,
  dataTest: PropTypes.string
};

export default PaymentInfoSectionHeader;
